import React from 'react';
import styled from 'styled-components';

const StyledTriggerElement = styled.div`
  width: 1px;
  height: 1px;
`;

export interface ScrollTriggerProps {
  onChange: (isVisible: boolean) => void;
}

export const ScrollTrigger = ({ onChange }: ScrollTriggerProps) => {
  const [isOnScreen, setIsOnScreen] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);
  const observerRef = React.useRef<IntersectionObserver>();

  React.useEffect(() => {
    observerRef.current = new IntersectionObserver(([entry]) => setIsOnScreen(entry.isIntersecting));
  }, []);

  React.useEffect(() => {
    if (!ref.current) return;
    if (!observerRef.current) return;
    observerRef.current.observe(ref.current);

    return () => {
      if (!observerRef.current) return;
      observerRef.current.disconnect();
    };
  }, [ref]);

  React.useEffect(() => {
    onChange(isOnScreen);
  }, [isOnScreen, onChange]);

  return <StyledTriggerElement ref={ref} />;
};
